<!--
Reusable nutrition summary card: renders calories/protein/carbohydrates/fats totals.
Shows an "estimated" badge when some ingredient lines couldn't be resolved into
nutrition data (unknown ingredient, missing nutrition facts, or an unconvertible
unit) so totals are never presented as more precise than they are.

`basis-label` states exactly what the numbers below it mean (per serving, per
100g, total for N servings, ...) — a bare number never appears without saying
what it's a quantity OF, since "230 kcal" is meaningless without knowing
whether that's one serving or the whole dish.

<NutritionFacts :totals="nutrition.total" :incomplete="nutrition.unknown.length > 0"
    basis-label="Ανά μερίδα" />
-->
<template>
    <div class="nutrition_facts" v-if="totals">
        <div class="nutrition_header">
            <h3>{{ $t('nutrition.title') }}</h3>
            <span class="incomplete_badge" v-if="incomplete">{{ $t('nutrition.estimated') }}</span>
        </div>
        <p class="basis_label" v-if="basisLabel">{{ basisLabel }}</p>
        <ul class="nutrition_list">
            <li>
                <span class="nutrition_label">{{ $t('nutrition.calories') }}</span>
                <span class="nutrition_value">{{ totals.calories }} kcal</span>
            </li>
            <li>
                <span class="nutrition_label">{{ $t('nutrition.protein') }}</span>
                <span class="nutrition_value">{{ totals.protein }} g</span>
            </li>
            <li>
                <span class="nutrition_label">{{ $t('nutrition.carbohydrates') }}</span>
                <span class="nutrition_value">{{ totals.carbohydrates }} g</span>
            </li>
            <li>
                <span class="nutrition_label">{{ $t('nutrition.fats') }}</span>
                <span class="nutrition_value">{{ totals.fats }} g</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "NutritionFacts",
    props: {
        totals: { type: Object, default: null },
        incomplete: { type: Boolean, default: false },
        basisLabel: { type: String, default: null }
    }
}
</script>

<style scoped>
.nutrition_facts {
    text-align: left;
}
.nutrition_header {
    display: flex;
    align-items: baseline;
    gap: 0.6rem;
}
.nutrition_header h3 {
    font-size: 1rem;
    margin: 0;
}
.basis_label {
    margin: 0.2rem 0 0;
    font-size: 0.8rem;
    color: var(--color-grey-2);
}
.incomplete_badge {
    font-size: 0.75rem;
    color: var(--color-grey-2);
    border: 1px solid var(--color-grey-1);
    border-radius: 50px;
    padding: 0.1rem 0.6rem;
}
.nutrition_list {
    list-style: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem 1.2rem;
    margin: 0.4rem 0 0;
}
.nutrition_list li {
    display: flex;
    gap: 0.4rem;
}
.nutrition_label {
    color: var(--color-grey-2);
}
.nutrition_value {
    font-weight: 600;
}
</style>
